import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { fromEvent, Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { selectTermsAndConditions, selectDisclaimers, selectCountrySelected } from '../main.selectors';
import { printTermsAndConditions } from '../../utils';
import { Subscription } from 'rxjs';
import { selectAuthLoggedIn } from '../../../features/auth/auth.selectors';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { getCurrentYear } from '../../utils';
import { ModalComponent } from 'atlas-modal';
import { DialogSizings, IconSizes, LogoColors, LogoModes } from 'atlas-cdk';
import { LinkTargets } from 'atlas-link';
import { FooterLink, FooterSocialIcon } from 'atlas-navigation';
@Component({
  standalone: false,
  selector: 'dsp-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  @ViewChild('termsModal')
  public termsModal: ModalComponent;
  @ViewChild('disclaimersModal')
  public disclaimersModal: ModalComponent

  public terms$: Observable<string>;
  public disclaimers$: Observable<string>;
  private readonly subscription: Subscription = new Subscription();
  selectedCountry = '';
  public authToken$: Observable<Boolean>;
  public env = environment;
  public copyRightYear = getCurrentYear();
  copyright = `© ${getCurrentYear()} Marsh. All rights reserved.`;
  brandUrl = 'https://www.corporate.marsh.com';
  brandIcon = 'Marsh-Logo';
  brandIconCollection = 'brand-logos';
  brandIconSize = IconSizes.xxxlarge;
  brandIconColor = LogoColors['brand-neutral'];
  brandLogoMode = LogoModes.dark;
  public modalSize: DialogSizings = DialogSizings.xlarge;

  mercerBusinessLinks: FooterLink[] = [
    { label: 'Risk and insurance', url: 'https://www.marsh.com', target: LinkTargets.blank, external: true },
    { label: 'Reinsurance and capital', url: 'https://www.guycarp.com/', target: LinkTargets.blank, external: true },
    { label: 'People and investments', url: 'https://www.mercer.com/', target: LinkTargets.blank, external: true },
    { label: 'Management consulting', url: 'https://www.oliverwyman.com/', target: LinkTargets.blank, external: true },
  ];
  mercerLegalLinks: FooterLink[] = [
    { label: 'Disclaimers', url: '#disclaimers', external: true, target: LinkTargets.self },
    { label: 'Terms & Conditions', url: '#terms', external: true, target: LinkTargets.self },
    { label: 'Privacy Notice', url: 'https://www.mercer.com.au/privacy.html', external: true, target: LinkTargets.blank },
    { label: 'Cookie Notice', url: 'https://www.mercer.com/regulatory/mercer-cookie-notice/', external: true, target: LinkTargets.blank },
  ];
  mercerSocialIcons: FooterSocialIcon[] = [];

  public constructor(
    // ,
    private readonly store: Store<AppState>,
    public route: Router
  ) {
    this.subscription.add(this.subscribeSelectedCountry());
    this.terms$ = this.store.pipe(select(selectTermsAndConditions));
    this.disclaimers$ = this.store.pipe(select(selectDisclaimers));
    this.authToken$ = this.store.pipe(select(selectAuthLoggedIn), map(token => !!token
      && !this.route.url.includes('provision/login')));
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onOpenTerms(): void {
    this.termsModal?.launch();
  }

  public onOpenDisclaimers(): void {
    this.disclaimersModal?.launch();
  }
  public termsAndConditions(termsAndConditionDivId) {
    return printTermsAndConditions(termsAndConditionDivId);

  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.selectedCountry = country;
    });
  }
  public navigateTo(link: string) {
    window.open(link, '_blank', 'noopener,noreferrer');
  }


  onFooterClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    const anchor = target?.closest('a');
    const href = anchor?.getAttribute('href')?.toLowerCase() || '';

    if (href.endsWith('#disclaimers')) {
      event.preventDefault();
      this.onOpenDisclaimers();
    } else if (href.endsWith('#terms')) {
      event.preventDefault();
      this.onOpenTerms();
    } else if (href === this.brandUrl) {
      event.preventDefault();
      this.navigateTo(this.brandUrl);
    }
  }
}
